// removed by extract-text-webpack-plugin
module.exports = {"text":"text__1L6Fq","xs":"xs__34uFW","sm":"sm__2gVLL","md":"md__2BZVW","lg":"lg__39HQX"};


//////////////////
// WEBPACK FOOTER
// ./components/typography/text/style.css
// module id = 4CJ7
// module chunks = 3